import React, { useEffect, useMemo, useState } from 'react';
// @ts-ignore
import styles from './WorkplaceWorkerHealthCareWorkerCode.module.scss';
import { Theme } from '../../../../../Enums/Theme.enum';
import Button from '../../../../../Components/Button/Button';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { MetaKey } from '../../../../Meta/Enums/MetaKey.enum';
import { findInMeta } from '../../../../Meta/Services/meta.service';
import Text from '../../../../../Components/Base/Text/Text';
import useWorkplaceMemberMeta from '../../../../WorkplaceMember/Hooks/useWorkplaceMemberMeta';
import { useAppContext } from '../../../../../Services/AppContext';
import NumberField from '../../../../../Components/Form/components/NumberField';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';

interface Props {
	userId: string;
}

const validationSchema = yup.object({
	healthCareWorkerCode: yup
		.string()
		.required(
			'validation.workplaceWorkerHealthCareWorkerCode.healthCareWorkerCode',
		),
});

const WorkplaceWorkerHealthCareWorkerCode: React.FC<Props> = ({ userId }) => {
	const [isEditMode, setIsEditMode] = useState(false);
	const { workplaceId } = useAppContext();
	const { workplaceMemberMeta, saveToWorkplaceMemberMeta, reFetchMeta } =
		useWorkplaceMemberMeta(userId, workplaceId);

	const healthCareWorkerCode: string | undefined = useMemo(() => {
		return findInMeta({
			meta: workplaceMemberMeta,
			metaKey: MetaKey.HEALTH_CARE_WORKER_CODE,
		})?.value;
	}, [workplaceMemberMeta]);

	const workload: string | undefined = useMemo(() => {
		return findInMeta({
			meta: workplaceMemberMeta,
			metaKey: MetaKey.WORKLOAD,
		})?.value;
	}, [workplaceMemberMeta]);

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	useEffect(() => {
		formMethods.reset({ healthCareWorkerCode, workload });
	}, [healthCareWorkerCode, workload]);

	const handleSubmit = async (values: any) => {
		await saveToWorkplaceMemberMeta({
			key: MetaKey.HEALTH_CARE_WORKER_CODE,
			value: values.healthCareWorkerCode,
		});
		await saveToWorkplaceMemberMeta({
			key: MetaKey.WORKLOAD,
			value: values.workload,
		});
		await reFetchMeta();
		setIsEditMode(false);
	};

	if (isEditMode) {
		return (
			<FormWrapper formMethods={formMethods}>
				<InputField
					name='healthCareWorkerCode'
					label='component.workplaceWorkerHealthCareWorkerCode.healthCareWorkerCode'
					className='mb-3'
					isRequired
				/>
				<InputWrapper>
					<NumberField
						label='component.rootWorkplaceSettingsSlovakia.workload'
						name='workload'
						isRequired
					/>
				</InputWrapper>
				<SubmitButton onSubmit={handleSubmit} title='base.shared.save' />
			</FormWrapper>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.item}>
				<Text tx='component.workplaceWorkerHealthCareWorkerCode.healthCareWorkerCode' />
				<div>
					<span>{healthCareWorkerCode}</span>
				</div>
			</div>
			<div className={styles.item}>
				<Text tx='component.rootWorkplaceSettingsSlovakia.workload' />
				<div>
					<span>{workload}</span>
				</div>
			</div>
			<Button
				theme={Theme.GREEN}
				title='base.shared.edit'
				className={styles.button}
				onClick={() => setIsEditMode(true)}
			/>
		</div>
	);
};

export default WorkplaceWorkerHealthCareWorkerCode;
